<p-toast position="top-right" />

<div class="flex flex-col md:flex-row h-screen overflow-hidden bg-dark-khaki-50 dark:bg-vivid-royal-950">
  <!-- Toast global -->
  <ng-container>
    <app-toast></app-toast>
  </ng-container>

  <!-- Sidebar desktop -->
  <aside class="hidden md:block flex-shrink-0 z-40">
    <app-sidebar></app-sidebar>
  </aside>

  <!-- Main content area -->
  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    <!-- Sidebar mobile -->
    <div class="md:hidden">
      <app-sidebar></app-sidebar>
    </div>
    <app-topbar [title]="titleBar"></app-topbar>
    <main class="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
      <router-outlet />
    </main>
  </div>
</div>

<!-- Tour Step 1 -->
<div *ngIf="isFirstTime && step === 1"
  class="fixed inset-0 z-50 bg-vivid-royal-950/85 flex items-center justify-center transition duration-150 ease-in-out">
  <div class="relative bg-mustard-500 shadow-lg rounded-xl p-6 md:p-8 w-11/12 max-w-md">
    <h1 class="text-vivid-royal-700 dark:text-vivid-royal-100 font-bold text-lg md:text-xl text-left uppercase underline">
      Bienvenido al nuevo portal
    </h1>
    <p class="text-vivid-royal-700 dark:text-vivid-royal-100 text-base font-semibold text-justify mt-4">
      Te daremos un breve recorrido para familiarizarte con las funciones que tenemos para ti
    </p>
    <div class="flex justify-end mt-4">
      <button class="text-vivid-royal-700 dark:text-vivid-royal-200 font-light cursor-pointer" (click)="nextStep()">Siguiente</button>
    </div>
    <button (click)="dismissTour()" class="absolute top-3 right-3 text-vivid-royal-900 cursor-pointer" aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z"/>
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>
</div>

<!-- Tour Step 2 -->
<div *ngIf="isFirstTime && step === 2"
  class="fixed inset-0 z-50 transition duration-150 ease-in-out">
  <div class="absolute inset-y-0 left-0 w-[300px] bg-vivid-royal-950/85"></div>
  <div class="absolute top-1/2 left-10 -translate-y-1/2 z-50">
    <div class="relative bg-mustard-500 shadow-lg rounded-xl p-6 w-[280px]">
      <p class="text-vivid-royal-700 dark:text-vivid-royal-100 text-sm font-semibold text-justify">
        Este es tu tablero. Aquí podrás visualizar un resumen de los datos principales de tu cuenta en números y gráficas
      </p>
      <div class="flex justify-end mt-4">
        <button class="text-vivid-royal-700 dark:text-vivid-royal-200 font-light cursor-pointer" (click)="nextStep()">Cerrar</button>
      </div>
      <button (click)="dismissTour()" class="absolute top-3 right-3 text-vivid-royal-900 cursor-pointer" aria-label="Cerrar">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z"/>
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
      <div class="absolute -right-8 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[30px] border-t-transparent border-l-[40px] border-l-mustard-500 border-b-[30px] border-b-transparent"></div>
    </div>
  </div>
</div>
